module.exports = __webpack_public_path__ + "img/Rookie-4.f07cedc9.gif";